import { render, staticRenderFns } from "./PerformanceCustomerCenterOverview.vue?vue&type=template&id=36844baf&scoped=true&"
import script from "./PerformanceCustomerCenterOverview.vue?vue&type=script&lang=ts&"
export * from "./PerformanceCustomerCenterOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceCustomerCenterOverview.vue?vue&type=style&index=0&id=36844baf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36844baf",
  null
  
)

export default component.exports